import { Link } from 'react-router-dom'
import { Github } from 'lucide-react'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <>
      <footer className="bg-slate-900/60 backdrop-blur-xl border-t border-cyan-500/30 shadow-lg shadow-cyan-500/5">
        <div className="max-w-6xl mx-auto px-3 py-2 sm:px-4 sm:py-3">
          <div className="flex flex-col gap-2 sm:gap-3">
            {/* Logo - Centered */}
            <div className="flex justify-center">
              <span className="text-sm sm:text-lg font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
                SWG: Origins
              </span>
            </div>

            {/* Links - Centered */}
            <div className="flex gap-2 sm:gap-4 text-xs justify-center">
              <Link to="/about" className="text-gray-400 hover:text-cyan-400 transition-colors duration-200">
                About
              </Link>
              <Link to="/server-info" className="text-gray-400 hover:text-cyan-400 transition-colors duration-200">
                Server Info
              </Link>
              <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-200">
                Discord
              </a>
              <Link to="/credits" className="text-gray-400 hover:text-cyan-400 transition-colors duration-200">
                Credits
              </Link>
            </div>

            {/* Powered by Core3 and Copyright centered */}
            <div className="flex justify-center items-center gap-4">
              {/* Powered by Core3 */}
              <div className="flex items-center gap-1 text-xs text-gray-500">
                <span>Powered by</span>
                <a 
                  href="https://github.com/swgemu/Core3" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 text-cyan-400 hover:text-cyan-300 transition-colors duration-200"
                >
                  <Github className="w-3 h-3 sm:w-4 sm:h-4" />
                  Core3
                </a>
              </div>

              {/* Copyright - Always shown */}
              <p className="text-gray-500 text-xs">
                © {currentYear} SWG: Origins
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
